import { Spinner2 } from 'components';
import { theme } from 'lib';
import styled from 'styled-components';

const Container = styled.div`
  width: 100vw;
  height: 100vh;
  background-color: rgba(210, 216, 223, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 2;
`;

const Loading = () => {
  return (
    <Container>
      <Spinner2 col={theme.SECONDARY} />
    </Container>
  );
};

export default Loading;
